/** Sets an entry and drops the oldest ones beyond the limit — never the pinned key. Keeps lookup caches bounded. */
export function withCappedEntry<T>(entries: Record<string, T>, key: string, value: T, limit: number, pinnedKey?: string): Record<string, T> {
  const next = { ...entries, [key]: value };
  const evictable = Object.keys(next).filter(entryKey => entryKey !== pinnedKey);
  evictable.slice(0, Math.max(0, evictable.length - limit)).forEach(entryKey => delete next[entryKey]);
  return next;
}
